import { LabelText } from "../Utils/Input"
import { FormattedNumber } from "./constants/FormatNumber"

export const SessionCards = ({ value }) => {
    return (
        <div>
            <div className="d-flex">
                <LabelText displayText={"Resource Name : "} />
                <p>&nbsp;{value.resourceName}</p>
            </div>
            <div className="mx-5">
                <div className="row">
                    {/* Reserved Balance Card */}
                    <div className="col-md-4 mb-2">
                        <div className="border rounded border-2">
                            <div className="card-body">
                                <LabelText displayText={"Reserved Balance "} />
                                <h1 className="card-text my-4 text-center session-card-font-size">
                                    <FormattedNumber value={value?.reservedBalance} uom={value.uom} />
                                </h1>
                            </div>
                        </div>
                    </div>

                    {/* Consumed Balance Card */}
                    <div className="col-md-4 mb-2">
                        <div className="border rounded border-2">
                            <div className="card-body">
                                <LabelText displayText={"Consumed Balance "} />
                                <h1 className="card-text my-4 text-center session-card-font-size">
                                    <FormattedNumber value={value?.consumedBalance} uom={value.uom} />
                                </h1>
                            </div>
                        </div>
                    </div>

                    {/* Remaining Balance Card */}
                    <div className="col-md-4">
                        <div className="border rounded border-2">
                            <div className="card-body">
                                <LabelText displayText={"Remaining Balance "} />
                                <h1 className="card-text  my-4 text-center session-card-font-size">
                                    <FormattedNumber value={value?.remainingBalance} uom={value.uom} />
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}